/**
 * BOGO bundles: quantity sync + dynamic prices on variant change (multi-currency via Intl).
 */
(function () {
  function findQuantityInput(productFormId, sectionId) {
    const form = document.getElementById(productFormId);
    if (!form) return null;

    let input = form.querySelector('input[name="quantity"]');
    if (input) return input;

    input = document.querySelector(
      'input[name="quantity"][form="' + productFormId.replace(/"/g, '\\"') + '"]'
    );
    if (input) return input;

    if (sectionId) {
      input = document.getElementById('Quantity-' + sectionId);
      if (input && input.name === 'quantity') return input;
    }

    return null;
  }

  function ensureQuantityInput(productFormId, sectionId, initialQty) {
    let input = findQuantityInput(productFormId, sectionId);
    if (input) return input;

    const form = document.getElementById(productFormId);
    if (!form) return null;

    input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'quantity';
    input.value = String(initialQty);
    input.setAttribute('data-bogo-bundle-quantity', 'true');
    form.appendChild(input);
    return input;
  }

  function setQuantity(productFormId, sectionId, qty) {
    const n = Math.max(1, parseInt(String(qty), 10) || 1);
    const input = ensureQuantityInput(productFormId, sectionId, n);
    if (!input) return;

    const min = parseInt(input.getAttribute('data-min') || input.min || '1', 10) || 1;
    const maxAttr = input.getAttribute('data-max') || input.max;
    const max = maxAttr ? parseInt(maxAttr, 10) : null;
    let v = Math.max(min, n);
    if (max != null && !isNaN(max)) v = Math.min(v, max);

    input.value = String(v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function formatMoneyFromCents(cents, currencyCode) {
    if (cents == null || isNaN(Number(cents))) return '';
    const amount = Number(cents) / 100;
    const code = currencyCode || 'USD';
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: code,
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(amount);
    } catch (e) {
      return amount.toFixed(2);
    }
  }

  function initDemandLiveCount(root) {
    const el = root.querySelector('[data-demand-live-count]');
    if (!el) return;
    if (root.getAttribute('data-demand-live-inited') === 'true') return;
    root.setAttribute('data-demand-live-inited', 'true');
    let min = parseInt(el.getAttribute('data-min'), 10);
    let max = parseInt(el.getAttribute('data-max'), 10);
    if (isNaN(min)) min = 71;
    if (isNaN(max)) max = 143;
    if (max < min) max = min;
    function tick() {
      const n = Math.floor(Math.random() * (max - min + 1)) + min;
      el.textContent = String(n);
    }
    tick();
    setInterval(tick, 3000);
  }

  function updateDynamicPrices(root, variant) {
    if (root.getAttribute('data-bogo-dynamic') !== 'true') return;

    const configEl = document.getElementById('BogoBundleConfig-' + root.dataset.sectionId);
    if (!configEl) return;

    let config;
    try {
      config = JSON.parse(configEl.textContent);
    } catch (e) {
      return;
    }

    if (!config.dynamic || !config.rows || !variant || variant.price == null) return;

    const priceCents = variant.price;
    const compareCents = variant.compare_at_price || 0;
    const currencyCode = config.currencyCode;
    const bundleBaseCents =
      typeof config.bundleBasePerPairCents === 'number' ? config.bundleBasePerPairCents : 0;
    const subtitlePrefix = typeof config.subtitlePrefix === 'string' ? config.subtitlePrefix : 'Save ';
    const subtitleSuffix = typeof config.subtitleSuffix === 'string' ? config.subtitleSuffix : '';
    config.rows.forEach(function (row) {
      const idx = row.index;
      const qty = typeof row.qty === 'number' ? row.qty : parseInt(row.qty, 10) || 0;
      const discount = typeof row.discount === 'number' ? row.discount : parseInt(row.discount, 10) || 0;
      let eachCents;
      let basePerPairCents = compareCents > priceCents ? compareCents : priceCents;
      if (bundleBaseCents > 0) {
        const totalOriginal = qty * bundleBaseCents;
        const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
        eachCents = Math.floor(totalDiscounted / qty);
        basePerPairCents = bundleBaseCents;
      } else if (qty === 1) {
        const totalOriginal = basePerPairCents;
        const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
        eachCents = totalDiscounted;
      } else {
        const totalOriginal = qty * basePerPairCents;
        const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
        eachCents = Math.floor(totalDiscounted / qty);
      }

      const rowWrap = root.querySelector('.js-bogo-price-current[data-bogo-row-index="' + idx + '"]');
      const amountEl = rowWrap ? rowWrap.querySelector('.js-bogo-price-amount') : null;
      const eachEl = rowWrap ? rowWrap.querySelector('.js-bogo-price-each') : null;
      const compareEl = root.querySelector('.js-bogo-price-compare[data-bogo-row-index="' + idx + '"]');

      const formatted = formatMoneyFromCents(eachCents, currencyCode);

      if (amountEl) amountEl.textContent = formatted;

      if (eachEl) {
        const showEach = !!row.priceEach;
        eachEl.hidden = !showEach;
        if (showEach) eachEl.removeAttribute('hidden');
        else eachEl.setAttribute('hidden', '');
      }

      if (compareEl) {
        compareEl.textContent = formatMoneyFromCents(basePerPairCents, currencyCode);
        compareEl.hidden = false;
        compareEl.removeAttribute('hidden');
      }

      const subtitleEl = root.querySelector('.js-bogo-subtitle[data-bogo-row-index="' + idx + '"]');
      if (subtitleEl) {
        let saveCents = 0;
        if (bundleBaseCents > 0) {
          const totalOriginal = qty * bundleBaseCents;
          const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
          saveCents = totalOriginal - totalDiscounted;
        } else if (qty === 1) {
          const totalOriginal = basePerPairCents;
          const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
          saveCents = totalOriginal - totalDiscounted;
        } else {
          const totalOriginal = qty * basePerPairCents;
          const totalDiscounted = Math.floor((totalOriginal * (100 - discount)) / 100);
          saveCents = totalOriginal - totalDiscounted;
        }
        if (saveCents > 0) {
          subtitleEl.textContent =
            subtitlePrefix + formatMoneyFromCents(saveCents, currencyCode) + subtitleSuffix;
          subtitleEl.hidden = false;
          subtitleEl.removeAttribute('hidden');
        } else {
          subtitleEl.textContent = '';
          subtitleEl.hidden = true;
        }
      }
    });
  }

  function initRoot(root) {
    const productFormId = root.getAttribute('data-product-form-id');
    const sectionId = root.getAttribute('data-section-id');
    if (!productFormId) return;

    initDemandLiveCount(root);

    const radios = root.querySelectorAll('.js-bogo-bundle-input');
    if (!radios.length) return;

    function syncFromChecked() {
      const checked = root.querySelector('.js-bogo-bundle-input:checked');
      if (!checked) return;
      const qty = checked.getAttribute('data-qty') || '1';
      setQuantity(productFormId, sectionId, qty);
    }

    radios.forEach(function (radio) {
      radio.addEventListener('change', syncFromChecked);
    });

    if (!root.querySelector('.js-bogo-bundle-input:checked')) {
      const first = root.querySelector('.js-bogo-bundle-input');
      if (first) first.checked = true;
    }

    syncFromChecked();

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.variantChange) {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const data = event && event.data;
        if (!data || !data.variant) return;
        if (String(data.sectionId) !== String(sectionId)) return;

        requestAnimationFrame(function () {
          updateDynamicPrices(root, data.variant);
          syncFromChecked();
        });
      });
    }
  }

  document.querySelectorAll('[data-bogo-bundles-root]').forEach(initRoot);
})();
